import { PopupContext } from '@app/dev/contexts/popup';
import { POPUPS } from '@common/constants/popups';
import { useTranslation } from '@common/hooks/translation';
import React, { useContext } from 'react';
import './style.scss';

const ClientDepositFailPopup = () => {
  const [{ openPopup, closePopup }] = useContext(PopupContext);
  const t = useTranslation();

  return (
    <div className="popup-content popup-small client-deposit-fail-popup">
      <h3 className="popup-title">{t('DEPOSIT FAILED: SESSION TIMEOUT')}</h3>

      <div className="popup-main-content">
        <div className="icon-block">
          <i className="global-icon icon-deposit-fail icon-alarm-clock" />
        </div>
        <p className="text-center">{t('You were inactive and no money was received during the transaction time limit.\nTo complete your deposit, you must start a new session.')}</p>
      </div>
      <div className="popup-actions">
        <button type="button" onClick={closePopup} className="popup-cancel-button">
          {t('Cancel')}
        </button>
        <button
          type="button"
          onClick={() => {
            openPopup(POPUPS.CLIENT_DEPOSIT_POPUP);
          }}
          className="popup-confirm-button"
        >
          {t('start new deposit')}
        </button>
      </div>
    </div>
  );
};

export default ClientDepositFailPopup;
